
import { computed, defineComponent, PropType, ref } from 'vue'
import { IVacancy, LocalizationPath } from '@tokyojob/core'
import {
  ButtonFactory,
  CButton,
  CIcon,
  CIconFactory,
  CVacancyImage,
  getLocalization,
  IconPlacement,
  IconSize
} from '@tokyojob/frontend-components'
import { LocalizationService, VacancyHasAppliedComposable } from '@tokyojob/frontend-core'
import CVacancyCardSmallMapMobile from '../c-vacancy-card-small-map-mobile/c-vacancy-card-small-map-mobile.component.vue'
import CVacancyCardSmallMapWeb from '../c-vacancy-card-small-map-web/c-vacancy-card-small-map-web.component.vue'
import { vacancyCardSmallMapUpdatedEvent } from './constants/events'
import { getProvidedApp } from '~/base/utils/provided-getter'

export default defineComponent({
  components: { CVacancyImage, CButton, CVacancyCardSmallMapMobile, CVacancyCardSmallMapWeb, CIcon },
  props: {
    /**
     * Vacancy object used to populate details of this card
     */
    vacancies: {
      type: Array as PropType<IVacancy[]>,
      required: true
    },
    /**
     * Index of vacancy to display
     */
    currentVacancyPage: {
      type: Number,
      required: false,
      default: 0
    },
  },
  setup(props, { emit }) {
    const localization = getLocalization(getProvidedApp())
    const multipleJobsStr = LocalizationService.t<string>(localization, LocalizationPath.multipleVacanciesAtLocation)
    const currentIndex = ref(props.currentVacancyPage)
    const vacancy = ref(props.vacancies[currentIndex.value])
    const prepositionText = LocalizationService.t<string>(localization, LocalizationPath.ofPreposition)

    const leftButton = ButtonFactory.button({
      icon: { icon: 'arrow-left', placement: IconPlacement.Left },
      label: LocalizationService.t<string>(localization, LocalizationPath.previousBtn),
      classes: 'row-center theme-shades-dark1-clear align-center g-5'
    })

    const rightButton = ButtonFactory.button({
      icon: { icon: 'arrow-right' },
      label: LocalizationService.t<string>(localization, LocalizationPath.nextBtn),
      classes: 'row-center theme-shades-dark1-clear align-center g-5'
    })

    const closeIcon = CIconFactory.Icon({
      icon: 'circle-xmark',
      size: IconSize.xlarge
    })

    const multipleVacancies = computed(() => {
      return props.vacancies.length > 1
    })
    const showPreviousButton = computed(() => {
      return currentIndex.value > 0
    })
    const showNextButton = computed(() => {
      return currentIndex.value < props.vacancies.length - 1
    })

    function nextVacancy(): void {
      if (currentIndex.value >= props.vacancies.length - 1) return
      currentIndex.value += 1
      vacancy.value = props.vacancies[currentIndex.value]
      emit(vacancyCardSmallMapUpdatedEvent, vacancy.value)
    }

    function previousVacancy(): void {
      if (currentIndex.value <= 0) return
      currentIndex.value -= 1
      vacancy.value = props.vacancies[currentIndex.value]
      emit(vacancyCardSmallMapUpdatedEvent, vacancy.value)
    }

    function closeInfoWindow() {
      emit('close')
    }

    const { hasApplied } = VacancyHasAppliedComposable()

    return {
      leftButton,
      rightButton,
      currentIndex,
      closeIcon,
      vacancy,
      multipleJobsStr,
      multipleVacancies,
      showNextButton,
      showPreviousButton,
      prepositionText,
      nextVacancy,
      previousVacancy,
      closeInfoWindow,
      hasApplied
    }
  }
})
